import { post } from '@/api/http'
import { jsFn } from '@/utils/jsFn'
import profile from '@/utils/profile'
// let hostname = window.location.hostname
var serverLocation = jsFn.isCN() ? 'cn' : 'global'

// if(hostname.indexOf('-rc') > 0) {
//     serverLocation += 'rc'
// }

// if(hostname.indexOf('localhost') === 0) {
//     serverLocation = 'globalrc'
// }

var apiUrl = profile.ies5Api[serverLocation]
export default {
    /** 申請加入學校 */
    applySchool: function(tokens, schoolCode){
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': tokens.token_type + ' ' + tokens.access_token,
                    'X-Auth-IdToken': tokens.id_token
                }
            }
            let data = {
                grant_type: 'request',
                school_code: schoolCode
            }

            post(apiUrl + '/hita/school-join-request', data, headers).then(() => {
                resolve(true)
            }, err => {
                reject(err)
            })
        })
    },
}